import React from "react";
import OrderCargoVolumeListPageContainer from "./OrderCargoVolumeListPageContainer";
export class OrderCargoVolumeListPage extends React.Component {
  render() {
    return <OrderCargoVolumeListPageContainer {...this.props} />;
  }
}
